import React from 'react'
import { Grid, Typography, Divider, Box } from '@mui/material'
import '../../../styles/report.css'
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
/** 
 * 
 * This component is expecting the following input. 
{
    "Order": "90",
    "Visible": "",
    "Label": "Mood",
    "SubSections": [
        {
            "Order": "10",
            "Visible": "1",
            "Label": "Stress",
            "Value": "Never"
        }
    ]
}
        {
            "Order": "20",
            "Visible": "1",
            "Label": "Depression",
            "Value": "Never"
        },
        {
            "Order": "30",
            "Visible": "1",
            "Label": "Little interest or pleasure",
            "Value": "Never"
        },
        {
            "Order": "40",
            "Visible": "1",
            "Label": "Anxious",
            "Value": "Never"
        },
        {
            "Order": "50",
            "Visible": "1",
            "Label": "Worried",
            "Value": "Never"
        }
    ],
    "ComponentType": "STANDARD SUBSECTION"
}

*/
const motionVariants = {
    hidden: { opacity: 0, x: 0, y: 25 },
    show: {
        opacity: 1, x: 0, y: 0,
        transition: {
            delay: 0.1,
            duration: 0.5,
        }
    }
}

const SubSection = (props) => {
    const OrderedSubSections = [...props.component.SubSections].sort(function (a, b) { return parseInt(a.Order) - parseInt(b.Order) })
    const FilteredSubsections = OrderedSubSections.filter((a) => { return a.Visible === '1' })

    const DisplayItem = ({ displayValues }) => {
        return (
            <motion.div variants={motionVariants} initial="hidden" animate="show" >
                <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                    <Grid container direction="row" alignItems="center" spacing={2}>
                        <Grid item xs={7}>
                            <Typography variant="body2" align="left">{displayValues.Label}</Typography>
                        </Grid>
                        <Grid item xs={5}>
                            <Typography variant="body2" align="left">{displayValues.Value}</Typography>
                        </Grid>
                    </Grid>
                </Box>
            </motion.div>
        )
    }

    return (
        <Grid container direction="row" mt={1}>
            <Grid item xs={12}>
                <Box>
                    <Typography variant="body1" fontWeight="bold" align="center">{props.component.Label}</Typography>
                </Box>
            </Grid>
            <Grid item xs={12} m={1}>
                <Divider orientation='horizontal' sx={{ borderColor: "rgba(0,0,0,0.1)", borderRadius: '90%', borderBottomWidth: 2 }} />
            </Grid>
            <Grid item xs={12} >

                {
                    FilteredSubsections && FilteredSubsections.map((displayValues, index) => {
                        return (
                            // <DisplayItem displayValues={displayValues}  />
                            <motion.div variants={motionVariants} initial="hidden" animate="show" key={"demographics" + index} >
                                <Box sx={{ borderBottom: 1, borderColor: "rgba(200,200,200,0.4)" }}>
                                    <Grid container direction="row" alignItems="center" spacing={2}>
                                        <Grid item xs={7}>
                                            <Typography variant="body2" align="left">{displayValues.Label}</Typography>
                                        </Grid>
                                        <Grid item xs={5}>
                                            <Typography variant="body2" align="left">{displayValues.Value}</Typography>
                                        </Grid>
                                    </Grid>
                                </Box>
                            </motion.div>
                        )
                    })
                }
            </Grid>

        </Grid>
    )
}

export default SubSection